/**
 * Recovery for a tab left open across a deploy.
 *
 * The tab keeps running the build it loaded, and route chunks load lazily. The
 * server keeps the previous build's files for a while, but a tab older than
 * that asks for a chunk that is gone, and Vite raises vite:preloadError. A
 * reload fetches the current build; the replica in IndexedDB makes it quick.
 *
 * At most once a minute, so a chunk that is genuinely missing shows its error
 * instead of reloading forever.
 */

const KEY = "stale-build-reloaded-at";
const MIN_INTERVAL_MS = 60_000;

function reloadedRecently(now: number): boolean {
  try {
    return now - Number(sessionStorage.getItem(KEY) ?? 0) < MIN_INTERVAL_MS;
  } catch {
    // Storage blocked: one reload is still better than a broken page.
    return false;
  }
}

function remember(now: number): void {
  try {
    sessionStorage.setItem(KEY, String(now));
  } catch {
    // See above.
  }
}

export function reloadOnStaleBuild(): void {
  window.addEventListener("vite:preloadError", (event) => {
    const now = Date.now();
    if (reloadedRecently(now)) return;
    remember(now);
    event.preventDefault();
    window.location.reload();
  });
}
